/*
 * @Auther: 罗耀祖
 * @Date: 2022-05-25 09:55:15
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-25 10:00:56
 * @name: 无需token页面
 * @Description: 无需token页面
 * @FilePath: \preSaleNafterSaleBackstage\src\config\unNeedToken.config.js
 * @Author: desktop
 */
export default ['/login', '/register', '/forgetPassword', '/preSaleNafterSaleDistributorApp', '/preSaleNafterSaleInsideApp']